import { render, staticRenderFns } from "./CouponEdit.vue?vue&type=template&id=6c690b96&scoped=true&"
import script from "./CouponEdit.vue?vue&type=script&lang=js&"
export * from "./CouponEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c690b96",
  null
  
)

export default component.exports